import { useState } from 'react';
import './App.css';
import './V2HomeCardItem.css';

function V2HomeCardItem({
    title,
    onClick,
    deactivated,
}) {
    const [showUpgrade, setShowUpgrade] = useState(false);

    return (
        <div
            className='v2-home-card-item'
            onClick={onClick}
            style={{
                display: 'flex',
                alignItems: 'center',
                color: deactivated ? 'grey' : null,
            }}
            onMouseEnter={() => setShowUpgrade(true)}
            onMouseLeave={() => setShowUpgrade(false)}
        >
            {title}
            {
                deactivated && showUpgrade &&
                <div
                    style={{
                        marginLeft: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                    className='v2-home-card-item-upgrade'
                >
                    <div style={{ marginRight: '0.2em' }}>
                        <i className="pi pi-send"></i>
                    </div>
                    <div>
                        upgrade
                    </div>
                </div>
            }
        </div>
    );
}

export default V2HomeCardItem;